export default function initForms() {
    function setOrigemMedia() {
        if (!sessionStorage.getItem("origem-eleva-harmonia-studios-media")) {
            let referrer = document.referrer;
            let utms = getQueryParameter("utm_source");
            let utmm = getQueryParameter("utm_medium");
            let utmc = getQueryParameter("utm_campaign");

            let midia = "Acesso Direto";
            let conversao = "Acesso Direto";

            if (referrer) {
                midia = "Google Orgânico";
                conversao = "Google Orgânico";
            }

            if (utms) {
                midia = utms + ">" + utmm;
                conversao = utmc;
            }

            let origem = {
                midia,
                conversao,
            };

            sessionStorage.setItem(
                "origem-eleva-harmonia-studios-media",
                JSON.stringify(origem),
            );
        }
    }

    function getQueryParameter(param) {
        return new URLSearchParams(document.location.search.substring(1)).get(
            param,
        );
    }

    setOrigemMedia();

    $('form.send-cv').submit(function (event) {
        event.preventDefault(); // Evita o envio padrão do formulário

        const form = $(this);
        const button = form.find("button");
        let formData = form.serialize();

        let origemStr = sessionStorage.getItem(
            "origem-eleva-harmonia-studios-media",
        );

        if (origemStr) {
            try {
                const origem = JSON.parse(origemStr);
                const params = new URLSearchParams(formData);

                let origemCompleta = origem.midia;

                if (origem.conversao && origem.conversao !== origem.midia) {
                    origemCompleta += " - " + origem.conversao;
                }

                params.append("midia", origemCompleta);

                formData = params.toString();
            } catch (e) {
                console.error("Erro ao fazer parse da origem", e);
            }
        }

        button.prop("disabled", true).text("Enviando...");

        $.ajax({
            url: "integracao.php",
            type: "POST",
            data: formData,
            success: function (response) {
                dataLayer.push({ event: "form-submit-sucess" });

                button.prop("disabled", true).text("Enviado com sucesso!");

                form[0].reset();

                $("#modalSucesso").fadeIn();
            },
            error: function (xhr, status, error) {
                const errorMsg =
                    xhr.responseJSON && xhr.responseJSON.message
                        ? xhr.responseJSON.message
                        : "Ocorreu um erro ao enviar. Tente novamente.";

                button.prop("disabled", true).text(errorMsg);
            },
            complete: function () {
                setTimeout(() => {
                    button.prop("disabled", false).text("Enviar");
                }, 3000);
            },
        });
    });

    $('form[name="formModal"]').on("submit", function (event) {
        event.preventDefault();

        $.ajax({
            url: $(this).attr("action"),
            type: "POST",
            data: $(this).serialize(),
            success: function (response) {
                $("#modalSucesso").fadeIn();
            },
            error: function (xhr, status, error) {
                $("#modalErro").fadeIn();
            },
        });
    });
}
